import { useMemo } from "react";

import { MainNavigationItem } from "components/MainNavigation/types";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import {
  MAIN_NAVIGATION_SECONDARY_MENU_ITEMS,
  MainNavigationSecondaryMenuItemKeys,
} from "./menuItemsSecondary";

const useLaunchPageItem = (): MainNavigationItem | undefined => {
  const { viewer } = useTypedContext(AccountContext);

  const isAdmin = viewer.admin;

  const item = useMemo(
    () => MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Launchpad],
    []
  );

  if (!isAdmin) {
    return undefined;
  }

  return item;
};

export default useLaunchPageItem;
